import type { ChatPermissions, ChatSettingKeys, ServiceMessagePermissionKey } from "./types"

export const CHAT_SETTING_KEYS = {
  AI_ENABLED: "ai_enabled",
  IMAGE_GENERATION_ENABLED: "image_generation_enabled",
  VIDEO_GENERATION_ENABLED: "video_generation_enabled",
  VOICE_GENERATION_ENABLED: "voice_generation_enabled",
  FUN_COMMAND_ENABLED: "fun_command_enabled",
  HISTORY_COMMAND_ENABLED: "history_command_enabled",
  RANDOM_BANTER_ENABLED: "random_banter_enabled",
  RANDOM_REACTION_ENABLED: "random_reaction_enabled",
  CASINO_ENABLED: "casino_enabled",
  MENTION_USERS_IN_TOP_CMD: "mention_users_in_top_cmd",
  AI_HISTORY_SUMMARY_ENABLED: "ai_history_summary_enabled",
  RANKS_AND_RATINGS_ENABLED: "ranks_and_ratings_enabled",
  AUTO_TRANSCRIPTION_ENABLED: "auto_transcription_enabled"
} as const satisfies Record<string, Exclude<keyof ChatPermissions, ServiceMessagePermissionKey>>

export const LEGACY_CHAT_SETTING_KEY_ALIASES = {
  voice_enabled: CHAT_SETTING_KEYS.VOICE_GENERATION_ENABLED
} as const satisfies Partial<Record<string, ChatSettingKeys>>

export const CHAT_PERMISSION_KEYS = [
  "ai_enabled",
  "image_generation_enabled",
  "video_generation_enabled",
  "voice_generation_enabled",
  "fun_command_enabled",
  "history_command_enabled",
  "random_banter_enabled",
  "random_reaction_enabled",
  "casino_enabled",
  "mention_users_in_top_cmd",
  "ai_history_summary_enabled",
  "ranks_and_ratings_enabled",
  "auto_transcription_enabled",
  "service_messages_enabled",
  "invitation_message_enabled",
  "invite_rewards_notifications_enabled"
] as const satisfies ReadonlyArray<keyof ChatPermissions>
